const formatName = (name: string) => {
  const splitName = name.split(' ');

  const nameFormatted = `${splitName[0]} ${splitName[1] ? splitName[1] : ''}`;

  return nameFormatted;
};

export { formatName };
